export const getNonEmptyRegisterState = <T extends Record<string, unknown>>(
    params: T,
): T | undefined => {
    if (Object.values(params).some((value) => value !== undefined && value !== null)) {
        return params;
    }

    return undefined;
};
